
export default function usePaymentOrder() {

  const bankCodeList = [
    {
      value: "2001",
      label: "BANXICO",
    },
    {
      value: "37006",
      label: "BANCOMEXT",
    },
    {
      value: "37009",
      label: "BANOBRAS",
    },
    {
      value: "37019",
      label: "BANJERCITO",
    },
    {
      value: "37135",
      label: "NAFIN",
    },
    {
      value: "37166",
      label: "BANSEFI",
    },
    {
      value: "37168",
      label: "HIPOTECARIA FED",
    },
    {
      value: "40002",
      label: "BANAMEX",
    },
    {
      value: "40012",
      label: "BBVA BANCOMER",
    },
    {
      value: "40014",
      label: "SANTANDER",
    },
    {
      value: "40021",
      label: "HSBC",
    },
    {
      value: "40030",
      label: "BAJIO",
    },
    {
      value: "40036",
      label: "INBURSA",
    },
    {
      value: "40042",
      label: "MIFEL",
    },
    {
      value: "40044",
      label: "SCOTIABANK",
    },
    {
      value: "40058",
      label: "BANREGIO",
    },
    {
      value: "40059",
      label: "INVEX",
    },
    {
      value: "40060",
      label: "BANSI",
    },
    {
      value: "40062",
      label: "AFIRME",
    },
    {
      value: "40072",
      label: "BANORTE",
    },
    {
      value: "40102",
      label: "ACCENDO BANCO",
    },
    {
      value: "40103",
      label: "AMERICAN EXPRES",
    },
    {
      value: "40106",
      label: "BANK OF AMERICA",
    },
    {
      value: "40108",
      label: "MUFG",
    },
    {
      value: "40110",
      label: "JP MORGAN",
    },
    {
      value: "40112",
      label: "BMONEX",
    },
    {
      value: "40113",
      label: "VE POR MAS",
    },
    {
      value: "40124",
      label: "DEUTSCHE",
    },
    {
      value: "40126",
      label: "CREDIT SUISSE",
    },
    {
      value: "40127",
      label: "AZTECA",
    },
    {
      value: "40128",
      label: "AUTOFIN",
    },
    {
      value: "40129",
      label: "BARCLAYS",
    },
    {
      value: "40130",
      label: "COMPARTAMOS",
    },
    {
      value: "40132",
      label: "MULTIVA BANCO",
    },
    {
      value: "40133",
      label: "ACTINVER",
    },
    {
      value: "40136",
      label: "INTERCAM BANCO",
    },
    {
      value: "40137",
      label: "BANCOPPEL",
    },
    {
      value: "40138",
      label: "ABC CAPITAL",
    },
    {
      value: "40140",
      label: "CONSUBANCO",
    },
    {
      value: "40141",
      label: "VOLKSWAGEN",
    },
    {
      value: "40143",
      label: "CIBANCO",
    },
    {
      value: "40145",
      label: "BBASE",
    },
    {
      value: "40147",
      label: "BANKAOOL",
    },
    {
      value: "40148",
      label: "PAGATODO",
    },
    {
      value: "40150",
      label: "INMOBILIARIO",
    },
    {
      value: "40151",
      label: "DONDE",
    },
    {
      value: "40152",
      label: "BANCREA",
    },
    {
      value: "40154",
      label: "BANCO FINTERRA",
    },
    {
      value: "40155",
      label: "ICBC",
    },
    {
      value: "40156",
      label: "SABADELL",
    },
    {
      value: "40157",
      label: "SHINHAN",
    },
    {
      value: "40158",
      label: "MIZUHO BANK",
    },
    {
      value: "40160",
      label: "BANCO S3",
    },
    {
      value: "90600",
      label: "MONEXCB",
    },
    {
      value: "90601",
      label: "GBM",
    },
    {
      value: "90602",
      label: "MASARI",
    },
    {
      value: "90605",
      label: "VALUE",
    },
    {
      value: "90606",
      label: "ESTRUCTURADORES",
    },
    {
      value: "90608",
      label: "VECTOR",
    },
    {
      value: "90613",
      label: "MULTIVA CBOLSA",
    },
    {
      value: "90616",
      label: "FINAMEX",
    },
    {
      value: "90617",
      label: "VALMEX",
    },
    {
      value: "90620",
      label: "PROFUTURO",
    },
    {
      value: "90630",
      label: "CB INTERCAM",
    },
    {
      value: "90631",
      label: "CI BOLSA",
    },
    {
      value: "90634",
      label: "FINCOMUN",
    },
    {
      value: "90636",
      label: "HDI SEGUROS",
    },
    {
      value: "90638",
      label: "AKALA",
    },
    {
      value: "90642",
      label: "REFORMA",
    },
    {
      value: "90646",
      label: "STP",
    },
    {
      value: "90648",
      label: "EVERCORE",
    },
    {
      value: "90652",
      label: "CREDICAPITAL",
    },
    {
      value: "90653",
      label: "KUSPIT",
    },
    {
      value: "90656",
      label: "UNAGRA",
    },
    {
      value: "90659",
      label: "ASP INTEGRA OPC",
    },
    {
      value: "90670",
      label: "LIBERTAD",
    },
    {
      value: "90677",
      label: "CAJA POP MEXICA",
    },
    {
      value: "90680",
      label: "CRISTOBAL COLON",
    },
    {
      value: "90683",
      label: "CAJA TELEFONIST",
    },
    {
      value: "90684",
      label: "TRANSFER",
    },
    {
      value: "90685",
      label: "FONDO (FIRA)",
    },
    {
      value: "90686",
      label: "INVERCAP",
    },
    {
      value: "90689",
      label: "FOMPED",
    },
    {
      value: "90902",
      label: "INDEVAL",
    },
    {
      value: "90903",
      label: "CoDi Valida",
    },
    {
      value: "90814",
      label: "SANTANDER2",
    },
  ]
  const documentTypeList = [
    {
      value: "CURP",
      label: "CURP",
    },
    {
      value: "ND",
      label: "ND",
    },
    {
      value: "RFC",
      label: "RFC",
    },
  ]
  const bankOptions = [
    { id: 1, value: "001", description: "BCO DO BRASIL S.A." },
    { id: 3, value: "003", description: "BCO DA AMAZONIA S.A." },
    { id: 4, value: "004", description: "BCO DO NORDESTE DO BRASIL S.A." },
    { id: 7, value: "007", description: "BNDES" },
    { id: 10, value: "010", description: "CREDICOAMO" },
    { id: 11, value: "011", description: "C.SUISSE HEDGING" },
    { id: 12, value: "012", description: "BANCO INBURSA" },
    { id: 14, value: "014", description: "STATE STREET BR S.A. BCO COMERCIAL" },
    { id: 15, value: "015", description: "UBS BRASIL CCTVM S.A." },
    { id: 16, value: "016", description: "CCM DESP TRÂNS SC E RS" },
    { id: 17, value: "017", description: "BNY MELLON BCO S.A." },
    { id: 18, value: "018", description: "BCO TRICURY S.A." },
    { id: 21, value: "021", description: "BCO BANESTES S.A." },
    { id: 24, value: "024", description: "BCO BANDEPE S.A." },
    { id: 25, value: "025", description: "BCO ALFA S.A." },
    { id: 29, value: "029", description: "BANCO ITAÚ CONSIGNADO S.A." },
    { id: 33, value: "033", description: "BCO SANTANDER (BRASIL) S.A." },
    { id: 36, value: "036", description: "BCO BBI S.A." },
    { id: 37, value: "037", description: "BCO DO EST. DO PA S.A." },
    { id: 40, value: "040", description: "BCO CARGILL S.A." },
    { id: 41, value: "041", description: "BCO DO ESTADO DO RS S.A." },
    { id: 47, value: "047", description: "BCO DO EST. DE SE S.A." },
    { id: 60, value: "060", description: "CONFIDENCE CC S.A." },
    { id: 62, value: "062", description: "HIPERCARD BM S.A." },
    { id: 63, value: "063", description: "BANCO BRADESCARD" },
    { id: 64, value: "064", description: "GOLDMAN SACHS DO BRASIL BM S.A." },
    { id: 65, value: "065", description: "BCO ANDBANK S.A." },
    { id: 66, value: "066", description: "BCO MORGAN STANLEY S.A." },
    { id: 69, value: "069", description: "BCO CREFISA S.A." },
    { id: 70, value: "070", description: "BRB" },
    { id: 74, value: "074", description: "BCO. J.SAFRA S.A." },
    { id: 75, value: "075", description: "BCO ABN AMRO S.A." },
    { id: 76, value: "076", description: "BCO KDB BRASIL S.A." },
    { id: 77, value: "077", description: "BANCO INTER" },
    { id: 78, value: "078", description: "HAITONG BI DO BRASIL S.A." },
    { id: 79, value: "079", description: "BCO ORIGINAL DO AGRO S/A" },
    { id: 80, value: "080", description: "B&T CC LTDA." },
    { id: 81, value: "081", description: "BANCOSEGURO S.A." },
    { id: 82, value: "082", description: "BANCO TOPÁZIO S.A." },
    { id: 83, value: "083", description: "BCO DA CHINA BRASIL S.A." },
    { id: 84, value: "084", description: "UNIPRIME NORTE DO PARANÁ" },
    { id: 85, value: "085", description: "COOP CENTRAL AILOS" },
    { id: 88, value: "088", description: "BANCO RANDON S.A." },
    { id: 89, value: "089", description: "CREDISAN CC" },
    { id: 91, value: "091", description: "CCCM UNICRED CENTRAL RS" },
    { id: 92, value: "092", description: "BRK S.A. CFI" },
    { id: 93, value: "093", description: "POLOCRED SCMEPP LTDA." },
    { id: 94, value: "094", description: "BANCO FINAXIS" },
    { id: 95, value: "095", description: "TRAVELEX BANCO DE CÂMBIO S.A." },
    { id: 96, value: "096", description: "BCO B3 S.A." },
    { id: 97, value: "097", description: "CREDISIS CENTRAL DE COOPERATIVAS DE CRÉDITO LTDA." },
    { id: 98, value: "098", description: "CREDIALIANÇA CCR" },
    { id: 99, value: "099", description: "UNIPRIME CENTRAL CCC LTDA." },
    { id: 100, value: "100", description: "PLANNER CV S.A." },
    { id: 101, value: "101", description: "RENASCENCA DTVM LTDA" },
    { id: 102, value: "102", description: "XP INVESTIMENTOS CCTVM S/A" },
    { id: 104, value: "104", description: "CAIXA ECONOMICA FEDERAL" },
    { id: 105, value: "105", description: "LECCA CFI S.A." },
    { id: 107, value: "107", description: "BCO BOCOM BBM S.A." },
    { id: 108, value: "108", description: "PORTOCRED S.A." },
    { id: 111, value: "111", description: "OLIVEIRA TRUST DTVM S.A." },
    { id: 113, value: "113", description: "MAGLIANO S.A. CCVM" },
    { id: 114, value: "114", description: "CENTRAL COOPERATIVA DE CRÉDITO NO ESTADO DO ESPÍRITO SANTO" },
    { id: 117, value: "117", description: "ADVANCED CC LTDA" },
    { id: 119, value: "119", description: "BCO WESTERN UNION" },
    { id: 120, value: "120", description: "BCO RODOBENS S.A." },
    { id: 121, value: "121", description: "BCO AGIBANK S.A." },
    { id: 122, value: "122", description: "BCO BRADESCO BERJ S.A." },
    { id: 124, value: "124", description: "BCO WOORI BANK DO BRASIL S.A." },
    { id: 125, value: "125", description: "BANCO GENIAL" },
    { id: 126, value: "126", description: "BR PARTNERS BI" },
    { id: 127, value: "127", description: "CODEPE CVC S.A." },
    { id: 128, value: "128", description: "MS BANK S.A. BCO DE CÂMBIO" },
    { id: 129, value: "129", description: "UBS BRASIL BI S.A." },
    { id: 130, value: "130", description: "CARUANA SCFI" },
    { id: 131, value: "131", description: "TULLETT PREBON BRASIL CVC LTDA" },
    { id: 132, value: "132", description: "ICBC DO BRASIL BM S.A." },
    { id: 133, value: "133", description: "CRESOL CONFEDERAÇÃO" },
    { id: 134, value: "134", description: "BGC LIQUIDEZ DTVM LTDA" },
    { id: 136, value: "136", description: "CONF NAC COOP CENTRAIS UNICRED" },
    { id: 138, value: "138", description: "GET MONEY CC LTDA" },
    { id: 139, value: "139", description: "INTESA SANPAOLO BRASIL S.A. BM" },
    { id: 140, value: "140", description: "EASYNVEST" },
    { id: 142, value: "142", description: "BROKER BRASIL CC LTDA." },
    { id: 143, value: "143", description: "TREVISO CC S.A." },
    { id: 144, value: "144", description: "BEXS BCO DE CAMBIO S.A." },
    { id: 145, value: "145", description: "LEVYCAM CCV LTDA" },
    { id: 146, value: "146", description: "GUITTA CC LTDA" },
    { id: 149, value: "149", description: "FACTA S.A. CFI" },
    { id: 157, value: "157", description: "ICAP DO BRASIL CTVM LTDA." },
    { id: 159, value: "159", description: "CASA CREDITO S.A. SCM" },
    { id: 163, value: "163", description: "COMMERZBANK BRASIL S.A." },
    { id: 173, value: "173", description: "BRL TRUST DTVM SA" },
    { id: 174, value: "174", description: "PEFISA S.A." },
    { id: 177, value: "177", description: "GUIDE" },
    { id: 180, value: "180", description: "CM CAPITAL MARKETS CCTVM LTDA" },
    { id: 183, value: "183", description: "SOCRED SA" },
    { id: 184, value: "184", description: "BCO ITAÚ BBA S.A." },
    { id: 188, value: "188", description: "ATIVA S.A. INVESTIMENTOS CCTVM" },
    { id: 189, value: "189", description: "HS FINANCEIRA" },
    { id: 190, value: "190", description: "SERVICOOP" },
    { id: 191, value: "191", description: "NOVA FUTURA CTVM LTDA." },
    { id: 194, value: "194", description: "PARMETAL DTVM LTDA" },
    { id: 196, value: "196", description: "FAIR CC S.A." },
    { id: 197, value: "197", description: "STONE PAGAMENTOS S.A." },
    { id: 208, value: "208", description: "BANCO BTG PACTUAL S.A." },
    { id: 212, value: "212", description: "BANCO ORIGINAL" },
    { id: 213, value: "213", description: "BCO ARBI S.A." },
    { id: 217, value: "217", description: "BANCO JOHN DEERE S.A." },
    { id: 218, value: "218", description: "BCO BS2 S.A." },
    { id: 222, value: "222", description: "BCO CRÉDIT AGRICOLE BR S.A." },
    { id: 224, value: "224", description: "BCO FIBRA S.A." },
    { id: 233, value: "233", description: "BANCO CIFRA" },
    { id: 237, value: "237", description: "BCO BRADESCO S.A." },
    { id: 241, value: "241", description: "BCO CLASSICO S.A." },
    { id: 243, value: "243", description: "BCO MÁXIMA S.A." },
    { id: 246, value: "246", description: "BCO ABC BRASIL S.A." },
    { id: 249, value: "249", description: "BANCO INVESTCRED UNIBANCO S.A." },
    { id: 250, value: "250", description: "BCV" },
    { id: 253, value: "253", description: "BEXS CC S.A." },
    { id: 254, value: "254", description: "PARANA BCO S.A." },
    { id: 259, value: "259", description: "MONEYCORP BCO DE CÂMBIO S.A." },
    { id: 260, value: "260", description: "NU PAGAMENTOS S.A." },
    { id: 265, value: "265", description: "BCO FATOR S.A." },
    { id: 266, value: "266", description: "BCO CEDULA S.A." },
    { id: 268, value: "268", description: "BARI CIA HIPOTECÁRIA" },
    { id: 269, value: "269", description: "BCO HSBC S.A." },
    { id: 270, value: "270", description: "SAGITUR CC LTDA" },
    { id: 271, value: "271", description: "IB CCTVM S.A." },
    { id: 272, value: "272", description: "AGK CC S.A." },
    { id: 273, value: "273", description: "CCR DE SÃO MIGUEL DO OESTE" },
    { id: 274, value: "274", description: "MONEY PLUS SCMEPP LTDA" },
    { id: 276, value: "276", description: "BCO SENFF S.A." },
    { id: 278, value: "278", description: "GENIAL INVESTIMENTOS CVM S.A." },
    { id: 279, value: "279", description: "CCR DE PRIMAVERA DO LESTE" },
    { id: 280, value: "280", description: "WILL FINANCEIRA S.A.CFI" },
    { id: 281, value: "281", description: "CCR COOPAVEL" },
    { id: 283, value: "283", description: "RB INVESTIMENTOS DTVM LTDA." },
    { id: 285, value: "285", description: "FRENTE CC LTDA." },
    { id: 286, value: "286", description: "CCR DE OURO" },
    { id: 288, value: "288", description: "CAROL DTVM LTDA." },
    { id: 289, value: "289", description: "DECYSEO CC LTDA." },
    { id: 290, value: "290", description: "PAGSEGURO S.A." },
    { id: 292, value: "292", description: "BS2 DTVM S.A." },
    { id: 293, value: "293", description: "LASTRO RDV DTVM LTDA" },
    { id: 296, value: "296", description: "VISION S.A. CC" },
    { id: 298, value: "298", description: "VIPS CC LTDA." },
    { id: 299, value: "299", description: "BCO SOROCRED S.A." },
    { id: 300, value: "300", description: "BCO LA NACION ARGENTINA" },
    { id: 301, value: "301", description: "BPP IP S.A." },
    { id: 306, value: "306", description: "PORTOPAR DTVM LTDA" },
    { id: 307, value: "307", description: "TERRA INVESTIMENTOS DTVM" },
    { id: 309, value: "309", description: "CAMBIONET CC LTDA" },
    { id: 310, value: "310", description: "VORTX DTVM LTDA." },
    { id: 311, value: "311", description: "DOURADA CORRETORA" },
    { id: 312, value: "312", description: "HSCM SCMEPP LTDA." },
    { id: 313, value: "313", description: "AMAZÔNIA CC LTDA." },
    { id: 315, value: "315", description: "PI DTVM S.A." },
    { id: 318, value: "318", description: "BCO BMG S.A." },
    { id: 319, value: "319", description: "OM DTVM LTDA" },
    { id: 320, value: "320", description: "BCO CCB BRASIL S.A." },
    { id: 321, value: "321", description: "CREFAZ SCMEPP LTDA" },
    { id: 322, value: "322", description: "CCR DE ABELARDO LUZ" },
    { id: 323, value: "323", description: "MERCADO PAGO" },
    { id: 324, value: "324", description: "CARTOS SCD S.A." },
    { id: 325, value: "325", description: "ÓRAMA DTVM S.A." },
    { id: 326, value: "326", description: "PARATI" },
    { id: 328, value: "328", description: "CECM FABRIC CALÇADOS SAPIRANGA" },
    { id: 329, value: "329", description: "QI SCD S.A." },
    { id: 330, value: "330", description: "BANCO BARI S.A." },
    { id: 331, value: "331", description: "FRAM CAPITAL DTVM S.A." },
    { id: 332, value: "332", description: "ACESSO SOLUCOES PAGAMENTO SA" },
    { id: 335, value: "335", description: "BANCO DIGIO" },
    { id: 336, value: "336", description: "BCO C6 S.A." },
    { id: 340, value: "340", description: "SUPER PAGAMENTOS E ADMINISTRACAO DE MEIOS ELETRONICOS S.A." },
    { id: 341, value: "341", description: "ITAÚ UNIBANCO S.A." },
    { id: 342, value: "342", description: "CREDITAS SCD" },
    { id: 343, value: "343", description: "FFA SCMEPP LTDA." },
    { id: 348, value: "348", description: "BCO XP S.A." },
    { id: 349, value: "349", description: "AL5 S.A. CFI" },
    { id: 350, value: "350", description: "CREHNOR LARANJEIRAS" },
    { id: 352, value: "352", description: "TORO CTVM LTDA" },
    { id: 354, value: "354", description: "NECTON INVESTIMENTOS S.A CVM" },
    { id: 355, value: "355", description: "ÓTIMO SCD S.A." },
    { id: 358, value: "358", description: "MIDWAY S.A." },
    { id: 359, value: "359", description: "ZEMA CFI S/A" },
    { id: 360, value: "360", description: "TRINUS CAPITAL DTVM" },
    { id: 362, value: "362", description: "CIELO S.A." },
    { id: 363, value: "363", description: "SINGULARE CTVM S.A." },
    { id: 364, value: "364", description: "GERENCIANET" },
    { id: 365, value: "365", description: "SIMPAUL" },
    { id: 366, value: "366", description: "BCO SOCIETE GENERALE BRASIL" },
    { id: 367, value: "367", description: "VITREO DTVM S.A." },
    { id: 368, value: "368", description: "BCO CSF S.A." },
    { id: 370, value: "370", description: "BCO MIZUHO S.A." },
    { id: 371, value: "371", description: "WARREN CVMC LTDA" },
    { id: 373, value: "373", description: "UP.P SEP S.A." },
    { id: 374, value: "374", description: "REALIZE CFI S.A." },
    { id: 376, value: "376", description: "BCO J.P. MORGAN S.A." },
    { id: 377, value: "377", description: "BMS SCD S.A." },
    { id: 378, value: "378", description: "BBC LEASING" },
    { id: 379, value: "379", description: "CECM COOPERFORTE" },
    { id: 380, value: "380", description: "PICPAY" },
    { id: 381, value: "381", description: "BCO MERCEDES" },
    { id: 382, value: "382", description: "FIDUCIA SCMEPP LTDA" },
    { id: 383, value: "383", description: "JUNO" },
    { id: 384, value: "384", description: "GLOBAL SCM LTDA" },
    { id: 386, value: "386", description: "NU FINANCEIRA S.A. CFI" },
    { id: 387, value: "387", description: "BCO TOYOTA DO BRASIL S.A." },
    { id: 389, value: "389", description: "BCO MERCANTIL DO BRASIL S.A." },
    { id: 390, value: "390", description: "BCO GM S.A." },
    { id: 391, value: "391", description: "CCR DE IBIAM" },
    { id: 393, value: "393", description: "BCO VOLKSWAGEN S.A" },
    { id: 394, value: "394", description: "BCO BRADESCO FINANC. S.A." },
    { id: 395, value: "395", description: "F D GOLD DTVM LTDA" },
    { id: 396, value: "396", description: "HUB PAGAMENTOS" },
    { id: 397, value: "397", description: "LISTO SCD S.A." },
    { id: 398, value: "398", description: "IDEAL CTVM S.A." },
    { id: 399, value: "399", description: "KIRTON BANK" },
    { id: 400, value: "400", description: "CC POUP SER FIN CO" },
    { id: 401, value: "401", description: "IUGU SERVICOS NA INTERNET S/A" },
    { id: 402, value: "402", description: "COBUCCIO SCD S.A." },
    { id: 403, value: "403", description: "CORA SCD S.A." },
    { id: 404, value: "404", description: "SUMUP SCD S.A." },
    { id: 406, value: "406", description: "ACCREDITO SCD S.A." },
    { id: 407, value: "407", description: "ÍNDIGO INVESTIMENTOS DTVM LTDA." },
    { id: 408, value: "408", description: "BONUSPAGO SCD S.A." },
    { id: 410, value: "410", description: "PLANNER SCM S.A." },
    { id: 411, value: "411", description: "VIA CERTA FINANCIADORA S.A." },
    { id: 412, value: "412", description: "BCO CAPITAL S.A." },
    { id: 414, value: "414", description: "WORK SCD S.A." },
    { id: 416, value: "416", description: "LAMARA SCD S.A." },
    { id: 419, value: "419", description: "NUMBRS SCD S.A." },
    { id: 422, value: "422", description: "BCO SAFRA S.A." },
    { id: 427, value: "427", description: "CRED-UFES" },
    { id: 428, value: "428", description: "CRED-SYSTEM SCD S.A." },
    { id: 438, value: "438", description: "PLANNER TRUSTEE DTVM LTDA" },
    { id: 456, value: "456", description: "BCO MUFG BRASIL S.A." },
    { id: 464, value: "464", description: "BCO SUMITOMO MITSUI BRASIL S.A." },
    { id: 473, value: "473", description: "BCO CAIXA GERAL BRASIL S.A." },
    { id: 477, value: "477", description: "CITIBANK N.A." },
    { id: 479, value: "479", description: "BCO ITAUBANK S.A." },
    { id: 487, value: "487", description: "DEUTSCHE BANK S.A.BCO ALEMAO" },
    { id: 488, value: "488", description: "JPMORGAN CHASE BANK" },
    { id: 492, value: "492", description: "ING BANK N.V." },
    { id: 495, value: "495", description: "BCO LA PROVINCIA B AIRES BCE" },
    { id: 505, value: "505", description: "BCO CREDIT SUISSE S.A." },
    { id: 545, value: "545", description: "SENSO CCVM S.A." },
    { id: 600, value: "600", description: "BCO LUSO BRASILEIRO S.A." },
    { id: 604, value: "604", description: "BCO INDUSTRIAL DO BRASIL S.A." },
    { id: 610, value: "610", description: "BCO VR S.A." },
    { id: 611, value: "611", description: "BCO PAULISTA S.A." },
    { id: 612, value: "612", description: "BCO GUANABARA S.A." },
    { id: 613, value: "613", description: "OMNI BANCO S.A." },
    { id: 623, value: "623", description: "BANCO PAN" },
    { id: 626, value: "626", description: "BCO C6 CONSIG" },
    { id: 630, value: "630", description: "SMARTBANK" },
    { id: 633, value: "633", description: "BCO RENDIMENTO S.A." },
    { id: 634, value: "634", description: "BCO TRIANGULO S.A." },
    { id: 637, value: "637", description: "BCO SOFISA S.A." },
    { id: 643, value: "643", description: "BCO PINE S.A." },
    { id: 652, value: "652", description: "ITAÚ UNIBANCO HOLDING S.A." },
    { id: 653, value: "653", description: "BCO INDUSVAL S.A." },
    { id: 654, value: "654", description: "BCO DIGIMAIS S.A." },
    { id: 655, value: "655", description: "BCO VOTORANTIM S.A." },
    { id: 707, value: "707", description: "BCO DAYCOVAL S.A" },
    { id: 712, value: "712", description: "BCO OURINVEST S.A." },
    { id: 720, value: "720", description: "BCO RNX S.A." },
    { id: 739, value: "739", description: "BCO CETELEM S.A." },
    { id: 741, value: "741", description: "BCO RIBEIRAO PRETO S.A." },
    { id: 743, value: "743", description: "BANCO SEMEAR" },
    { id: 745, value: "745", description: "BCO CITIBANK S.A." },
    { id: 746, value: "746", description: "BCO MODAL S.A." },
    { id: 747, value: "747", description: "BCO RABOBANK INTL BRASIL S.A." },
    { id: 748, value: "748", description: "BCO COOPERATIVO SICREDI S.A." },
    { id: 751, value: "751", description: "SCOTIABANK BRASIL" },
    { id: 752, value: "752", description: "BCO BNP PARIBAS BRASIL S A" },
    { id: 753, value: "753", description: "NOVO BCO CONTINENTAL S.A." },
    { id: 754, value: "754", description: "BANCO SISTEMA" },
    { id: 755, value: "755", description: "BOFA MERRILL LYNCH BM S.A." },
    { id: 756, value: "756", description: "BANCO SICOOB S.A." },
    { id: 757, value: "757", description: "BCO KEB HANA DO BRASIL S.A." },
  ]
  const tzOptions = [
    // { label: 'Etc/GMT-12', value: 'Etc/GMT-12' },
    // { label: 'Etc/GMT-11', value: 'Etc/GMT-11' },
    // { label: 'Etc/GMT-10', value: 'Etc/GMT-10' },
    // { label: 'Etc/GMT-9', value: 'Etc/GMT-9' },
    { label: "Asia/Shanghai", value: "Etc/GMT-8" },
    // { label: 'Etc/GMT-7', value: 'Etc/GMT-7' },
    // { label: 'Etc/GMT-6', value: 'Etc/GMT-6' },
    // { label: 'Etc/GMT-5', value: 'Etc/GMT-5' },
    // { label: 'Etc/GMT-4', value: 'Etc/GMT-4' },
    // { label: 'Etc/GMT-3', value: 'Etc/GMT-3' },
    // { label: 'Etc/GMT-2', value: 'Etc/GMT-2' },
    // { label: 'Etc/GMT-1', value: 'Etc/GMT-1' },
    { label: "Etc/GMT", value: "Etc/GMT" },
    // { label: 'Etc/GMT+1', value: 'Etc/GMT+1' },
    // { label: 'Etc/GMT+2', value: 'Etc/GMT+2' },
    { label: "America/Sao_Paulo", value: "Etc/GMT+3" },
    // { label: 'Etc/GMT+4', value: 'Etc/GMT+4' },
    // { label: 'Etc/GMT+5', value: 'Etc/GMT+5' },
    { label: "America/Mexico_City", value: "Etc/GMT+6" },
    // { label: 'Etc/GMT+7', value: 'Etc/GMT+7' },
    // { label: 'Etc/GMT+8', value: 'Etc/GMT+8' },
    // { label: 'Etc/GMT+9', value: 'Etc/GMT+9' },
    // { label: 'Etc/GMT+10', value: 'Etc/GMT+10' },
    // { label: 'Etc/GMT+11', value: 'Etc/GMT+11' },
    // { label: 'Etc/GMT+12', value: 'Etc/GMT+12' },
  ]
  const showColumnsList = {
    transactionId: true,
    merchantReference: true,
    appName: true,
    referenceDateTime: true,
    method: true,
    channel: true,
    amount: true,
    status: true,
    muid: true,
    email: true,
    subject: true,
    updateTime: true,
  }
  const tableColumns = [
    { label: "Transaction Id", key: "transactionId", id: 0 },
    { label: "Merchant Reference", key: "merchantReference", id: 1 },
    { label: "App Name", key: "appName", id: 2 },
    { label: "Create Time", key: "referenceDateTime", id: 3 },
    { label: "Method", key: "method", id: 4 },
    { label: "Amount", key: "amount", id: 5 },
    { label: "Status", key: "status", id: 6 },
    { label: "Muid", key: "muid", id: 7 },
    { label: "Email", key: "email", id: 8 },
    { label: "Subject", key: "subject", id: 9 },
    { label: "UpdateTime", key: "update Time", id: 10 },
  ]
  const tableHeaderList = [
    { label: "tables.listing.transactionId", key: "transactionId", id: 0 },
    {
      label: "tables.listing.merchantReference",
      key: "merchantReference",
      id: 1,
    },
    { label: "tables.listing.appName", key: "appName", id: 2 },
    {
      label: "tables.listing.referenceDateTime",
      key: "referenceDateTime",
      id: 3,
    },
    { label: "tables.listing.method", key: "method", id: 4 },
    { label: "tables.listing.channel", key: "channel", id: 5 },
    { label: "tables.listing.amount", key: "amount", id: 6 },
    { label: "tables.listing.status", key: "status", id: 7 },
    { label: "tables.listing.muid", key: "muid", id: 8 },
    { label: "tables.listing.email", key: "email", id: 9 },
    { label: "tables.listing.subject", key: "subject", id: 10 },
    { label: "tables.listing.updateTime", key: "updateTime", id: 11 },
  ]
  const modeList = {
    "Transaction ID": "1",
    "Merchant Reference": "2",
    "Partner ID": "3",
    "Merchant UID": "4",
    Email: "5",
    "User Identify": "6",
    "Clabe": "9",
    "Clave de rastreo": "10" // Partner Status
  }
  const timeModeList = {
    "Create Time": "1",
    "Update Time": "2",
  }
  const timeZoneList = [
    // 增加墨西哥，哥伦比亚，智利、秘鲁、巴拿马、哥斯达黎加、厄瓜多尔
    "America/Sao_Paulo",
    "Etc/GMT",
    "Asia/Shanghai",
    "America/Mexico_City", // 墨西哥
    "America/Bogota", // 哥伦比亚
    "America/Santiago", // 智利 America/Santiago 首都  Pacific/Easter America/Punta_Arenas
    "America/Lima", // 秘鲁
    "America/Panama", // 巴拿马
    "America/Costa_Rica", // 哥斯达黎加
    "America/Guayaquil", // 厄瓜多尔 America/Guayaquil Pacific/Galapagos
  ]
  const buyerInfo = [
    /* { 'NAME': 'Hiago Azevedo Gritti', 'CPF': '14354478757' },
    { 'MUID': '12345678', 'Email': 'xxxxx@gmail.com' },  trans_base.payment_info:
    { 'CEP': '12345', 'Phone Number': '055-2333454' } */
    { NAME: "", CPF: "" },
    { MUID: "", Email: "" },
    { CEP: "", "Phone Number": "" },
    { "Card NO.": "" },
  ]
  const deviceInfo = {
    /* 'System': 'Windows 10',
    'Resolution': '1366*768',
    'Browser': 'Chrome',
    'IP': '177.207.192.143(Brazil)' */
  }
  const merchantInfo = {
    "App Name": "",
    "App ID": "",
    "Merchant Reference": "",
  }
  const payVouchers = [
    {
      name: "Payment Voucher",
      time: "N/A",
      url: "",
    },
    {
      name: "Personal I.D.",
      time: "N/A",
      url: "",
    },
    {
      name: "Proof of Address",
      time: "N/A",
      url: "",
    },
  ]
  const accountOptions = [
    { id: 1, description: "Conta corrente", value: "checking_account" },
    { id: 2, description: "Conta poupança", value: "savings_account" },
  ]
  const statusOptions = [
    // { label: 'Initial', value: '10001' },
    // { label: 'Processing', value: '18000' },
    // { label: 'Cancelled', value: '25000' },
    { label: 'Success', value: '20000' },
    // { label: 'Dispute', value: '30000' },
    { label: 'Refused', value: '21000' },
    { label: 'Refunded', value: '22000' },
    { label: 'ChargeBack', value: '23000' },
    // { label: 'ChargebackReversed', value: '23001' },
    // { label: 'RiskControl', value: '27000' },
    { label: 'Refund Refused', value: '22003' },
  ]
  return {
    bankCodeList, documentTypeList, bankOptions, tzOptions, showColumnsList, tableColumns, tableHeaderList, modeList, timeModeList, timeZoneList, buyerInfo, deviceInfo, merchantInfo, payVouchers, accountOptions, statusOptions
  }
}

